import React, { useContext } from "react";
import PropTypes from "prop-types";
import ShopContext from "services/ShopContext";
import ApiContext from "services/ApiContext";
import { useQuery } from "react-query";

function TradeInImage(props) {
  const { tID } = props;
  const shopID =
    useContext(ShopContext).selctShopID &&
    useContext(ShopContext).selctShopID.ID;
  const Axios = useContext(ApiContext);

  const { data: rData } = useQuery(
    `/shop/${shopID}/GetSingleTradeInRequest/${tID}`,
    async () => Axios.get(`/shop/${shopID}/GetSingleTradeInRequest/${tID}`)
  );

  return (
    <div>
      {rData?.data.CSToDispatchFileURLList.length === 0 ? (
        <div>
          <p className="text-dark">No Image</p>
        </div>
      ) : (
        <div>
          {rData?.data.CSToDispatchFileURLList.map((img) => (
            <div className="imgPreview mr-2">
              <img
                className="VimgCenter"
                alt="..."
                src={img}
                width="80px"
                height="80px"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
TradeInImage.propTypes = {
  tID: PropTypes.string.isRequired,
};
export default TradeInImage;
